module.exports = __webpack_public_path__ + "images/ID_me_Logo_24dabdb.jpg";